import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import useFetchIssuesAction from './hooks/useFetchIssuesAction';
import * as IssuesV2Store from '../../../redux/issuesV2';
import PaginationFooter from '../../generic/Pagination/PaginationFooter';

//  When the page changes, there is no need to do the summary fetch.
const shouldSkipSummaryFetch = true;

/**
 * Pagination component for IssuesV2.
 */
const IssuesPagination: VoidFunctionComponent = () => {
  const page = useSelector(IssuesV2Store.selectors.getPage);
  const count = useSelector(IssuesV2Store.selectors.getCount);
  const totalItems = useSelector(IssuesV2Store.selectors.getTotalNumberOfItems);
  const setPage = useFetchIssuesAction(IssuesV2Store.actions.setPage, shouldSkipSummaryFetch);
  const setCount = useFetchIssuesAction(IssuesV2Store.actions.setCount);

  if (totalItems === null) {
    return null;
  }

  return (
    <PaginationFooter
      page={page}
      count={count}
      totalItems={totalItems}
      setPage={setPage}
      setCount={setCount}
    />
  );
};

export default IssuesPagination;
